import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import './notfound.css';

const NotFound = () => {
    return (
        <div className="nf">
            <div className="nf__inner">
                <img
                    src={`${process.env.PUBLIC_URL}/nomeUnae.png`}
                    alt="UNAE Estudantil"
                    className="nf__logo"
                />

                <div className="nf__code-wrap">
                    <h1 className="nf__code">404</h1>
                </div>

                <p className="nf__eyebrow">Erro 404</p>
                <h2 className="nf__title">Página não encontrada</h2>
                <p className="nf__text">
                    O endereço que você tentou acessar não existe, mudou de lugar ou está temporariamente indisponível.
                </p>

                <Link to="/" className="nf__btn">
                    <ArrowLeft size={19} /> Voltar para o início
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
